import React, { useState, useEffect, useRef, useMemo } from "react";
import "./Streak.css";
import questionMarkIcon from "../../assets/Task/ReferImg.png";
import StreakBreakPoints from "../StreakBreakPoints/StreakBreakPoints";
import useUserInfo from "../../Hooks/useUserInfo";
import logo from "../../assets/images/meme-logo.svg";
import twitter from "../../assets/images/twitter.svg";
import Tv from "../Tv/Tv";
import ReferPage from "../ReferPage/ReferPage";
import Task from "../Task/Task";
import Spinner from "./Spinner"; // Import the spinner component
import cancelIcon from "../../assets/Task/cancelicon.svg";
import gift from "../../assets/images/gift.svg";
import { useAudio } from "../../Providers/AudioProvider";
import { logPageView } from "../../components/analytics";
import {
  getUserStreaks,
  calculateStreak,
  calculateStreakOfStreak,
  loginStreakRewardClaim,
  watchStreakRewardClaim,
  referStreakRewardClaim,
  taskStreakRewardClaim,
  multiStreakRewardClaim,
  streakOfStreakRewardClaim,
  getUserDetails1,
} from "../../apis/user";
import { differenceInDays } from "date-fns";
import fire from "../../assets/images/fire.svg";

const Streak = () => {
  const [day, setDay] = useState(1);
  const [normalDay, setNormalDay] = useState(1);
  var dayRef = useRef(1);
  const playClick = useAudio();

  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const [streakData, setStreakData] = useState(null);
  const [streakOfStreakData, setStreakOfStreakData] = useState(null);
  const userId = userDetails?.userDetails?.telegramId;
  useEffect(() => {
    logPageView("StreakPage", "Streak Page");
  }, []);

  useEffect(() => {
    if (userDetails.userDetails?.streakData) {
      setStreakData(userDetails.userDetails.streakData);
    }

    if (userDetails.userDetails?.streakOfStreakData) {
      setStreakOfStreakData(userDetails.userDetails.streakOfStreakData);
    }
  }, [userDetails]);
  const DefaultTelegramId = process.env.REACT_APP_DEFAULT_TELEGRAM;
  const WatchStreak = localStorage.getItem(`watchStreak_${userId}`);
  const ParsedWatchStreak = WatchStreak ? JSON.parse(WatchStreak) : 0;
  const WatchStreakValu1 = userDetails?.userDetails?.telegramId;
  const WatchStreakValu2 = userDetails ? "" : ParsedWatchStreak;
  const getAccumulatedWatchSec = localStorage.getItem(
    `accumulatedWatchSec_${userId}`
  );
  const [hasCalled, setHasCalled] = useState(false);
  useEffect(() => {
    if (Number(getAccumulatedWatchSec) >= 180 && !hasCalled) {
      postWatchStreak(WatchStreakValu1, WatchStreakValu2);
      setHasCalled(true); // Mark the function as called
    }
  }, [getAccumulatedWatchSec, hasCalled]);
  const postWatchStreak = async (id, ParsedWatchStreak) => {
    const calculatedStreakData = await calculateStreak({
      userWatchSeconds: 180,
    });
    if (calculatedStreakData) {
      localStorage.setItem(
        `watchStreak_${userId}`,
        JSON.stringify({
          watchSec: ParsedWatchStreak?.watchSec,
          date: new Date(userDetails?.userDetails?.lastLogin).getDate(),
          updated: true,
        })
      );
    }
  };

  const [streakOfStreakReward, setStreakOfStreakReward] = useState(0);
  const [streakOfStreakRewardPopUp, setStreakOfStreakRewardPopUp] = useState(0);

  //loader
  const [isLoginClaimLoading, setIsLoginClaimLoading] = useState(false);
  const [isWatchClaimLoading, setIsWatchClaimLoading] = useState(false);
  const [isReferClaimLoading, setIsReferClaimLoading] = useState(false);
  const [isTaskClaimLoading, setIsTaskClaimLoading] = useState(false);
  const [isMultiClaimLoading, setIsMultiClaimLoading] = useState(false);

  const [showPopup, setShowPopup] = useState(false); // Make sure this is initialized to false
  const closePopup = () => {
    setShowPopup(false); // Close the popup
    setStreakOfStreakRewardPopUp(0);
    playClick();
  };

  const dayRefs = useRef([]);
  const scrollToActiveDay = (dayIndex) => {
    if (dayRefs.current[dayIndex]) {
      dayRefs.current[dayIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
    }
  };
  const horizontalScrollableRef = useRef(null);
  const verticalScrollableRef = useRef(null);
  useEffect(() => {
    const preventTouchScroll = (event) => {
      const isHorizontalScrollable =
        horizontalScrollableRef.current &&
        horizontalScrollableRef.current.contains(event.target);
      const isVerticalScrollable =
        verticalScrollableRef.current &&
        verticalScrollableRef.current.contains(event.target);
      if (!isHorizontalScrollable && !isVerticalScrollable) {
        event.preventDefault();
      }
    };
    document.addEventListener("touchmove", preventTouchScroll, {
      passive: false,
    });
    return () => {
      document.removeEventListener("touchmove", preventTouchScroll);
    };
  }, []);

  // Scroll to the active day on page load
  useEffect(() => {
    scrollToActiveDay(normalDay - 1);
  }, [normalDay]);

  const goToThePage = (component, name) => {
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          centerCount: userDetails.centerCount + 1,
          isMenu: false,
        },
      };
    });
    playClick();
  };

  const [startDay, setStartDay] = useState(0);
  const [currentDay, setCurrentDay] = useState(0);

  const data = {
    name: userDetails?.userDetails?.name,
    telegramId: userDetails?.userDetails?.telegramId,
  };

  // const getUserDetails = async (data) => {
  //   const pointDetails = localStorage.getItem(`pointDetails_${userId}`);
  //   const parsedData = JSON.parse(pointDetails);

  //   var data1;
  //   var userDetails;
  //   if (parsedData?.watchSec) {
  //     data1 = {
  //       userWatchSeconds: parsedData?.watchSec,
  //       boosterPoints: String(
  //         Number(parsedData?.tapPoints) + Number(parsedData?.boosterPoints)
  //       ),
  //     };

  //     if (parsedData?.booster[0]) {
  //       data1.boosters = parsedData?.booster;
  //     }
  //     await updateWatchSecOnly(data1).then(async () => {
  //       userDetails = await UserDeatils(data);

  //       updateUserInfo((prev) => ({
  //         ...prev,
  //         userDetails: userDetails?.user,
  //       }));

  //       updatewatchScreenInfo((prev) => ({
  //         ...prev,
  //         boostersList: userDetails?.user?.boosters,
  //         totalReward: userDetails?.user?.balanceRewards,
  //       }));
  //     });
  //   } else {
  //     userDetails = await UserDeatils(data);

  //     updateUserInfo((prev) => ({
  //       ...prev,
  //       userDetails: userDetails,
  //     }));

  //     updatewatchScreenInfo((prev) => ({
  //       ...prev,
  //       boostersList: userDetails?.boosters,
  //       totalReward: userDetails?.balanceRewards,
  //     }));
  //   }

  //   return userDetails;
  // };

  useEffect(() => {
    console.log("Streak is running", currentDay);

    if (currentDay) {
      dayCheck(currentDay);
    } // You can provide any other value here based on your requirement
  }, [currentDay]); // Empty dependency array ensures this runs only on initial render

  // const updateWatchSecOnly = async (data) => {
  //   const res = await addWatchSeconds(data);
  //   localStorage.setItem(
  //     `pointDetails_${userId}`,
  //     JSON.stringify({
  //       tapPoints: 0,
  //       watchSec: 0,
  //       boosterPoints: 0,
  //       booster: [0],
  //     })
  //   );
  //   updatewatchScreenInfo((prev) => ({
  //     ...prev,
  //     tapPoints: 0,
  //     booster: false,
  //     boosterSec: 0,
  //     boosterPoints: 0,
  //     boosterDetails: {},
  //     watchSec: 0,
  //   }));
  // };

  const memoizedStartDay = useMemo(() => {
    // Some calculation that uses startDay
    return startDay; // Could be any complex calculation
  }, [startDay]);

  const memoizedCurrentDay = useMemo(() => {
    // Some calculation that uses currentDay
    return currentDay; // Could be any complex calculation
  }, [currentDay]);

  //function to check day cnd change the day, if they start in a middle day
  const dayCheck = async (n) => {
    setNormalDay(n);
    
    const dayCount = n - startDay;
    if (dayCount == 0) {
      setDay(1);
      dayRef.current = 1;
    } else if (dayCount == 1) {
      setDay(2);
      dayRef.current = 2;
    } else if (dayCount == 2) {
      setDay(3);
      dayRef.current = 3;
    } else if (dayCount == 3) {
      setDay(4);
      dayRef.current = 4;
    } else if (dayCount == 4) {
      setDay(5);
      dayRef.current = 5;
    } else if (dayCount == 5) {
      setDay(6);
      dayRef.current = 6;
    }
  };

  //function to calculate day reward
  const calculateReward = async () => {
    const data = {
      userWatchSeconds: 0,
    };
    // Fetch streak data
    const [calculatedStreakData, getStreakData] = await Promise.all([
      calculateStreak(data),
      getUserStreaks(data.telegramId),
    ]);
    setIsWatchClaimLoading(false);
    setIsLoginClaimLoading(false);
    setIsReferClaimLoading(false);
    setIsTaskClaimLoading(false);
    setIsMultiClaimLoading(false);
    // Update basic streak data
    setStreakData(calculatedStreakData);
    setCurrentDay(getStreakData?.currentDay);
    setStartDay(getStreakData?.startDay);
    setCurrentDay(getStreakData?.currentDay);

    if (
      calculatedStreakData.login &&
      calculatedStreakData.watch &&
      calculatedStreakData.refer &&
      calculatedStreakData.task
    ) {
      // Calculate and update streak of streak data if needed
      const calculatedStreakOfStreakData = await calculateStreakOfStreak(
        data.telegramId
      );
      // Check if there is no error message in the response
      if (
        calculatedStreakOfStreakData &&
        calculatedStreakOfStreakData.message !==
          "User has not completed all streaks"
      ) {
        // Update state only if there is no error
        setStreakOfStreakData(calculatedStreakOfStreakData);
        // Set the total unclaimed rewards from the new response format
        setStreakOfStreakReward(calculatedStreakOfStreakData.totalUnclaimedSOSRewards);
      } else {
        console.log("Error: " + calculatedStreakOfStreakData.message);
      }
    }
  };

  // Memoize login streak reward
  const memoizedLoginStreakReward = useMemo(() => {
    return streakData?.loginStreak?.loginStreakReward[normalDay-1] || 0;
  }, [streakData, dayRef.current]);

  // Memoize watch streak reward
  const memoizedWatchStreakReward = useMemo(() => {
    return streakData?.watchStreak?.watchStreakReward[normalDay-1] || 0;
  }, [streakData, dayRef.current]);
  // Memoize refer streak reward
  const memoizedReferStreakReward = useMemo(() => {
    return streakData?.referStreak?.referStreakReward[normalDay-1] || 0;
  }, [streakData, dayRef.current]);

  // Memoize task streak reward
  const memoizedTaskStreakReward = useMemo(() => {
    return streakData?.taskStreak?.taskStreakReward[normalDay-1] || 0;
  }, [streakData, dayRef.current]);

  // Memoize multi streak reward
  const memoizedMultiStreakReward = useMemo(() => {
    return (
      streakOfStreakData?.streakOfStreak?.multiStreakReward[
        normalDay-1
      ] || 0
    );
  }, [streakData, dayRef.current]);



  // Memoize login streak reward Unclaimed
  const memoizedLoginStreakRewardUnclaimed = useMemo(() => {
    return streakData?.loginStreak?.loginStreakRewardUnclaimed[normalDay-1] || 0;
  }, [streakData, dayRef.current]);

  // Memoize watch streak reward Unclaimed
  const memoizedWatchStreakRewardUnclaimed = useMemo(() => {
    return streakData?.watchStreak?.watchStreakRewardUnclaimed[normalDay-1] || 0;
  }, [streakData, dayRef.current]);
  // Memoize refer streak reward Unclaimed
  const memoizedReferStreakRewardUnclaimed = useMemo(() => {
    return streakData?.referStreak?.referStreakRewardUnclaimed[normalDay-1] || 0;
  }, [streakData, dayRef.current]);

  // Memoize task streak reward Unclaimed
  const memoizedTaskStreakRewardUnclaimed = useMemo(() => {
    return streakData?.taskStreak?.taskStreakRewardUnclaimed[normalDay-1] || 0;
  }, [streakData, dayRef.current]);

  // Memoize multi streak reward Unclaimed
  const memoizedMultiStreakRewardUnclaimed = useMemo(() => {
    return (
      streakOfStreakData?.streakOfStreak?.multiStreakRewardUnclaimed[
        normalDay-1
      ] || 0
    );
  }, [streakData, dayRef.current]);


  

  useEffect(() => {
    calculateReward();
  }, [day]);

  const handleLoginClaimClick = async () => {
    playClick();
    const data = {
      index: normalDay-1, // Adjust index based on current day
    };

    // Check if the login streak reward is not undefined
    if (
      streakData.loginStreak.loginStreakReward[normalDay-1] !== undefined
    ) {
      try {
        setIsLoginClaimLoading(true); // Start loading

        // Call the loginStreakRewardClaim function and pass the data
        const response = await loginStreakRewardClaim(data);
        // Reset the reward or perform other actions
        calculateReward();
      } catch (error) {
        console.error("Error during claim:", error);
      } finally {
        // setIsLoginClaimLoading(false); // End loading
      }
    }
  };

  const handleWatchClaimClick = async () => {
    playClick();

    const data = {
      index: normalDay-1, // Adjust index based on current day
    };

    // Check if the watch streak reward is not undefined
    if (
      streakData.watchStreak.watchStreakReward[normalDay-1] !== undefined
    ) {
      try {
        setIsWatchClaimLoading(true); // Start loading

        // Call the watchStreakRewardClaim function and pass the data
        const response = await watchStreakRewardClaim(data);

        calculateReward(); // Update any further reward calculations
      } catch (error) {
        console.error("Error during watch claim:", error);
      } finally {
        // setIsWatchClaimLoading(false); // End loading
      }
    }
  };

  const handleReferClaimClick = async () => {
    playClick();

    const data = {
      index: normalDay-1, // Adjust index based on current day
    };

    // Check if the refer streak reward is not undefined
    if (
      streakData.referStreak.referStreakReward[normalDay-1] !== undefined
    ) {
      try {
        setIsReferClaimLoading(true); // Start loading

        // Call the referStreakRewardClaim function and pass the data
        const response = await referStreakRewardClaim(data);
        calculateReward(); // Update any further reward calculations
      } catch (error) {
        console.error("Error during refer claim:", error);
      } finally {
        // setIsReferClaimLoading(false); // End loading
      }
    }
  };

  const handleGameClaimClick = async () => {
    playClick();
    const data = {
      index: normalDay-1, // Adjust index based on current day
    };
    

    // Check if the task streak reward is not undefined
    if (
      streakData.taskStreak.taskStreakReward[normalDay-1] !== undefined
    ) {
      try {
        setIsTaskClaimLoading(true); //Start loading
        // Call the taskStreakRewardClaim function and pass the data
        const response = await taskStreakRewardClaim(data);
        
        calculateReward(); // Update any further reward calculations
      } catch (error) {
        console.error("Error during task claim:", error);
      } finally {
        // setIsTaskClaimLoading(false); // End loading
      }
    }
  };

  const handleMultiClaimClick = async () => {
    playClick();
    // Check if all necessary streak data is available
    if (
      streakData.login &&
      streakData.watch &&
      streakData.refer &&
      streakData.task
    ) {


      const data = {
        index: normalDay-1, // Adjust index based on current day
      };

      // Check if the multi streak reward is not undefined
      if (
        streakOfStreakData.streakOfStreak.multiStreakReward[
          normalDay-1
        ] !== undefined
      ) {
        try {
          setIsMultiClaimLoading(true); // Start loading

          // Call the multiStreakRewardClaim function and pass the data
          const response = await multiStreakRewardClaim(data);
          
          // Reset the reward
          calculateReward(); // Update any further reward calculations
        } catch (error) {
          console.error("Error during multi claim:", error);
        } finally {
          // setIsMultiClaimLoading(false); // End loading
        }
      }
    }
  };

  const handleSOSClaimClick = async () => {
    console.log("Inside SOS claim click");
    if (
      streakData.login &&
      streakData.watch &&
      streakData.refer &&
      streakData.task
    ) {
      const data = {
        telegramId: userDetails.userDetails.telegramId,
      };
      
      // Check if there are unclaimed rewards
      if (streakOfStreakData?.totalUnclaimedSOSRewards > 0) {
        const response = await streakOfStreakRewardClaim();
        calculateReward();
        setStreakOfStreakRewardPopUp(streakOfStreakData.totalUnclaimedSOSRewards);
        setStreakOfStreakReward(0);
        // Show the popup after reward is claimed and set any UI state needed
        setShowPopup(true); // Show the popup here
      }
    }
  };

  useEffect(() => {
    const fetchStreakData = async () => {
      try {
        const data = {
          userWatchSeconds: 0,
        };
        // Fetch streak data using get api
        const getStreakData = await getUserStreaks(data.telegramId);
        console.log(getStreakData);
        
        if (getStreakData) {
          setStartDay(getStreakData.startDay);
          setCurrentDay(getStreakData.currentDay);
        }
        console.log(getStreakData);
        

        // Calculate streak data and update the state
        const calculatedStreakData = await calculateStreak(data);
        setStreakData(calculatedStreakData);
        if (
          calculatedStreakData.login &&
          calculatedStreakData.watch &&
          calculatedStreakData.refer &&
          calculatedStreakData.task
        ) {
          // Calculate and update streak of streak data if needed
          const calculatedStreakOfStreakData = await calculateStreakOfStreak(
            data.telegramId
          );
          // Check if there is no error message in the response
          if (
            calculatedStreakOfStreakData &&
            calculatedStreakOfStreakData.message !==
              "User has not completed all streaks"
          ) {
            // Update state only if there is no error
            setStreakOfStreakData(calculatedStreakOfStreakData);
          } else {
            console.log("Error: " + calculatedStreakOfStreakData.message);
          }
        }
        await calculateReward();
      } catch (error) {
        console.error("Error fetching or calculating streak data:", error);
      }
    };
    fetchStreakData();
  }, [userDetails.userDetails.telegramId]); // Dependency array to run the effect when telegramId changes

  useEffect(() => {
    setTimeout(() => {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }, 1000);
  }, []);
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const toogleMenu = () => {
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: Tv,
          currentComponentText: "TVPage",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: false,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "TVPage");
    }
    playClick();
  };


  //FUNCTION TO CHECK THE STREAK COUNT AND CURRENT DAY ARE IN THE SAME LINE
  const checkRewardArrayIndex = (streakType)=>
  {
    if(!streakData) return 0;
    const streak = streakData[streakType];
    // Handle case where streakData or required properties are missing
    if (!streak || !streak[`${streakType}Date`] || streak[`${streakType}Count`] === undefined) {
      return 0; // Return a default value (e.g., -1) or any meaningful value you prefer
    }
    const streakDate = streak[`${streakType}Date`].split("T")[0]
    const today = new Date().toISOString().split("T")[0];
    let diff;
    if (streakDate === today) {
      diff = currentDay - streak[`${streakType}Count`];
    } else {
      diff = currentDay - streak[`${streakType}Count`] - 1;
    }
    return diff;
  }

  return (
    <>
      <div className={` menupointer zindex ${showPopup ? "zindex1" : ""}`}>
        <div className="streakContainer mt-1">
          <img
            onClick={() => {
              toogleMenu();
            }}
            src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
            // className="cancel-imgpoints"
            className="cancel-imgleaderboard"
            style={{ cursor: "pointer", pointerEvents: "all" }}
          />
          <h1 className="streaktext">STREAK</h1>
          <img
            onMouseEnter={() => {
              goToThePage(StreakBreakPoints, "streakBreakPoints");
            }}
            src='https://d1ccopf5cw1hft.cloudfront.net/s3data/ReferImg.png'
            alt="Question Mark Icon"
            className="cancel-imgleaderboard1"
            style={{ marginLeft: "5px" }}
          />
        </div>
        <div
          className="container-fluid zindex"
          ref={horizontalScrollableRef}
          style={{ maxWidth: "300px", marginBottom: "10px", zIndex: "-1" }}
        >
          <div className="scrolling-wrapper row flex-row flex-nowrap">
            {Array.from({ length: 7 }).map((_, index) => (
              <div key={index} className="col-4">
                <div
                  ref={(el) => (dayRefs.current[index] = el)}
                  className={
                    memoizedStartDay > index + 1
                      ? "card-block1 card card-1 com-days"
                      : normalDay === index + 1
                      ? "card card-block2 card-1"
                      : "card card-block card-1"
                  }
                >
                  <button
                    className="btn-none"
                    onClick={() => {
                      playClick();
                      dayCheck(index + 1);
                    }}
                    disabled={memoizedStartDay > index + 1 ? true : false}
                  >
                    {" "}
                    DAY {index + 1}{" "}
                  </button>
                </div>
              </div>
            ))}
            
          </div>
        </div>
        <div className="scrollableContainerstrk" ref={verticalScrollableRef}>
          <div className="row mt10 cheap-stuff">
            <div className="col-2">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/a32d4767f07e35eed25cbb58c62b6e3e02828c9e572ce8ea3b6670916cbe8671?apiKey=da9eb044cac44bb1ab1471c98df94a03&&apiKey=da9eb044cac44bb1ab1471c98df94a03"
                alt="Login streak icon"
                className="image"
              />
            </div>
            <div className="col-7 stuff-text">
              <h4>LOGGED IN</h4>
              <p className="stuff-p">
                <img src={logo} />{" "}
                {`+${memoizedLoginStreakRewardUnclaimed}`}{" "}
              </p>
            </div>
            <div className="col-3">
              {/* If loading is true, show the loader */}
              {isLoginClaimLoading ? (
                <Spinner />
              ) : (
                <button
                  className={`stuff-claim ${
                    memoizedLoginStreakRewardUnclaimed===0 ||
                    memoizedCurrentDay < day + memoizedStartDay - 1
                      ? "claimed"
                      : memoizedLoginStreakReward > 0
                      ? ""
                      : "claimed"
                  }`}
                  onClick={handleLoginClaimClick}
                  style={{ cursor: "pointer" }}
                  disabled={memoizedCurrentDay === day + memoizedStartDay - 1 ? ((memoizedLoginStreakReward !== memoizedLoginStreakRewardUnclaimed ) ? true : false) : (memoizedLoginStreakReward > 0 ? false : true)}
                >
                    {memoizedCurrentDay < day + memoizedStartDay - 1 // after the current day
                    ?"LOCKED": (memoizedCurrentDay === day + memoizedStartDay - 1)
                    ? (memoizedLoginStreakReward===0 && memoizedLoginStreakRewardUnclaimed ===0
                      ?"GO"
                      :memoizedLoginStreakReward === memoizedLoginStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                    : (memoizedLoginStreakReward===0 && memoizedLoginStreakRewardUnclaimed ===0
                      ?"LOCKED"
                      :memoizedLoginStreakReward === memoizedLoginStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                    }{" "}
                </button>
              )}
            </div>
          </div>
          <div className="row mt10 cheap-stuff">
            <div className="col-2">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/2b5a03a049db265cb188f96311f2011c0d512a033e5d53ad816443dd4ad0eec1?apiKey=da9eb044cac44bb1ab1471c98df94a03&&apiKey=da9eb044cac44bb1ab1471c98df94a03"
                alt="Watch Streak Icon"
                className="image"
              />
            </div>
            <div className="col-7 stuff-text">
              <h4>WATCHED</h4>
              <p className="stuff-p">
                <img src={logo} />{" "}
                {`+${memoizedWatchStreakRewardUnclaimed}`}{" "}
              </p>
            </div>
            <div className="col-3">
              {isWatchClaimLoading ? (
                <Spinner />
              ) : (
                <button
                  className={`stuff-claim ${
                    memoizedWatchStreakRewardUnclaimed===0 ||
                    memoizedCurrentDay < day + memoizedStartDay - 1
                      ? "claimed"
                      : memoizedWatchStreakReward > 0
                      ? ""
                      : "claimed"
                  }`}
                  onClick={() => {
                    if (memoizedWatchStreakReward > 0) {
                      handleWatchClaimClick();
                    } else if (
                      memoizedCurrentDay >=
                      day + memoizedStartDay - 1
                    ) {
                      toogleMenu();
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  disabled={memoizedCurrentDay === day + memoizedStartDay - 1 ? ((memoizedWatchStreakReward !== memoizedWatchStreakRewardUnclaimed ) ? true : false) : (memoizedWatchStreakReward > 0 ? false : true)}
                >
                    {memoizedCurrentDay < day + memoizedStartDay - 1 // after the current day
                    ?"LOCKED": (memoizedCurrentDay === day + memoizedStartDay - 1)
                    ? (memoizedWatchStreakReward===0 && memoizedWatchStreakRewardUnclaimed ===0
                      ?"GO"
                      :memoizedWatchStreakReward === memoizedWatchStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                    : (memoizedWatchStreakReward===0 && memoizedWatchStreakRewardUnclaimed ===0
                      ?"LOCKED"
                      :memoizedWatchStreakReward === memoizedWatchStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                    }{" "}
                  {/* Catch-all to ensure fallback */}
                </button>
              )}
            </div>
          </div>
          <div className="row mt10 cheap-stuff">
            <div className="col-2">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/0eb953a6da27d088a419ecf530736727ca1f124475b9460d890398ef1438fc31?apiKey=da9eb044cac44bb1ab1471c98df94a03&&apiKey=da9eb044cac44bb1ab1471c98df94a03"
                className="image"
                alt=""
              />
            </div>
            <div className="col-7 stuff-text">
              <h4>REFERRED</h4>
              <p className="stuff-p">
                <img src={logo} />{" "}
                {`+${memoizedReferStreakRewardUnclaimed}`}{" "}
              </p>
            </div>
            <div className="col-3">
              {isReferClaimLoading ? (
                <Spinner />
              ) : (
                <button
                  className={`stuff-claim ${
                    memoizedReferStreakRewardUnclaimed===0 ||
                    memoizedCurrentDay < day + memoizedStartDay - 1
                      ? "claimed"
                      : memoizedReferStreakReward > 0
                      ? ""
                      : "claimed"
                  }`}
                  onClick={() => {
                    if (memoizedReferStreakReward > 0) {
                      handleReferClaimClick();
                    } else if (
                      memoizedCurrentDay >=
                      day + memoizedStartDay - 1
                    ) {
                      goToThePage(ReferPage, "ReferPage");
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  disabled={memoizedCurrentDay === day + memoizedStartDay - 1 ? ((memoizedReferStreakReward !== memoizedReferStreakRewardUnclaimed ) ? true : false) : (memoizedReferStreakReward > 0 ? false : true)}
                >
                  {memoizedCurrentDay < day + memoizedStartDay - 1 // after the current day
                    ?"LOCKED": (memoizedCurrentDay === day + memoizedStartDay - 1)
                    ? (memoizedReferStreakReward===0 && memoizedReferStreakRewardUnclaimed ===0
                      ?"GO"
                      :memoizedReferStreakReward === memoizedReferStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                    : (memoizedReferStreakReward===0 && memoizedReferStreakRewardUnclaimed ===0
                      ?"LOCKED"
                      :memoizedReferStreakReward === memoizedReferStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                  }{" "}
                </button>
              )}
            </div>
          </div>
          <div className="row mt10 cheap-stuff">
            <div className="col-2">
              <img
                loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/1d91855f4c21d7155a4b865bac0a53627ec417e8c7b74d7d40f533e5b8e895a3?apiKey=da9eb044cac44bb1ab1471c98df94a03&&apiKey=da9eb044cac44bb1ab1471c98df94a03"
                points="1,000"
                altText="Game icon"
                className="image"
                alt=""
              />
            </div>
            <div className="col-7 stuff-text">
              <h4>PLAYED</h4>
              <p className="stuff-p">
                <img src={logo} />{" "}
                {`+${memoizedTaskStreakRewardUnclaimed}`}{" "}
              </p>
            </div>
            <div className="col-3">
              {isTaskClaimLoading ? (
                <Spinner />
              ) : (
                <button
                  className={`stuff-claim ${
                    memoizedTaskStreakRewardUnclaimed===0 ||
                    memoizedCurrentDay < day + memoizedStartDay - 1
                      ? "claimed"
                      : memoizedTaskStreakReward > 0
                      ? ""
                      : "claimed"
                  }`}
                  onClick={() => {
                    if (memoizedTaskStreakReward > 0) {
                      handleGameClaimClick();
                    } else if (
                      memoizedCurrentDay >=
                      day + memoizedStartDay - 1
                    ) {
                      goToThePage(Task, "Task");
                    }
                  }}
                  style={{ cursor: "pointer" }}
                  disabled={memoizedCurrentDay === day + memoizedStartDay - 1 ? ((memoizedTaskStreakReward !== memoizedTaskStreakRewardUnclaimed ) ? true : false) : (memoizedTaskStreakReward > 0 ? false : true)}
                >
                  {memoizedCurrentDay < day + memoizedStartDay - 1 // after the current day
                    ?"LOCKED": (memoizedCurrentDay === day + memoizedStartDay - 1)
                    ? (memoizedTaskStreakReward===0 && memoizedTaskStreakRewardUnclaimed ===0
                      ?"GO"
                      :memoizedTaskStreakReward === memoizedTaskStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED"):
                       memoizedTaskStreakReward===0 && memoizedTaskStreakRewardUnclaimed ===0
                      ?"LOCKED"
                      :memoizedTaskStreakReward === memoizedTaskStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED"
                    
                  }{" "}
                </button>
              )}
            </div>
          </div>
          {/* <div className="row mt10 cheap-stuff mb10">
            <div className="col-2">
              <img loading="lazy" src={fire} className="image" alt="" />
            </div>
            <div className="col-7 stuff-text">
              <h4>MULTI STREAK</h4>
              <p className="stuff-p">
                <img src={logo} />{" "}
                {`+${memoizedMultiStreakRewardUnclaimed}`}{" "}
              </p>
            </div>
            <div className="col-3">
              {isMultiClaimLoading ? (
                <Spinner />
              ) : (
                <button
                  className={`stuff-claim ${
                    memoizedMultiStreakRewardUnclaimed===0 ||
                    memoizedCurrentDay < day + memoizedStartDay - 1
                      ? "claimed"
                      : memoizedMultiStreakReward > 0
                      ? ""
                      : "claimed"
                  }`}
                  onClick={handleMultiClaimClick}
                  style={{ cursor: "pointer" }}
                  disabled={memoizedCurrentDay === day + memoizedStartDay - 1 ? ((memoizedMultiStreakReward !== memoizedMultiStreakRewardUnclaimed ) ? true : false) : (memoizedMultiStreakReward > 0 ? false : true)}
                >
                  {memoizedCurrentDay < day + memoizedStartDay - 1 // after the current day
                    ?"LOCKED": (memoizedCurrentDay === day + memoizedStartDay - 1)
                    ? (memoizedMultiStreakReward===0 && memoizedMultiStreakRewardUnclaimed ===0
                      ?"GO"
                      :memoizedMultiStreakReward === memoizedMultiStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                    : (memoizedMultiStreakReward===0 && memoizedMultiStreakRewardUnclaimed ===0
                      ?"LOCKED"
                      :memoizedMultiStreakReward === memoizedMultiStreakRewardUnclaimed 
                       ?"CLAIM" : "CLAIMED")
                  }{" "}
                </button>
              )}
            </div>
          </div> */}
        </div>
      </div>

      <div
        className={
          streakOfStreakReward === 0 || streakOfStreakReward === undefined
            ? "invite-fri-sos"
            : "invite-sos"
        }
      >
        <button
          className={
            streakOfStreakReward === 0 || streakOfStreakReward === undefined
              ? "btn-none sos-none"
              : "sos"
          }
          onClick={handleSOSClaimClick}
          style={{ cursor: "pointer" }}
          disabled={
            streakOfStreakReward === 0 || streakOfStreakReward === undefined
              ? true
              : false
          }
        >
          STREAK OF STREAK
        </button>
        {showPopup && (
          <div className="popup1">
            <div className="popup-content1">
              <img src={gift} />
              <h2 className="epic1">STREAK OF STREAK REWARDS!</h2>
              
               <img style={{right: "45px"}}
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/Xicon.png"
                  className="cancel-img"
                  onClick={closePopup}
                />
              <div className="row text-center">
                <div className="col-12">
                  <div className="epic-div1">
                    {/* Display the correct streak reward */}
                    <h3 className="rw-popup1">
                      <img src={logo} alt="logo" /> {streakOfStreakRewardPopUp}!
                    </h3>
                  </div>
                </div>
              </div>
              <button className="btn-rewardsos" onClick={closePopup}>
                DONE
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default Streak;
